module.exports = __webpack_public_path__ + "img/product_45.8b24607.webp";